import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setModal } from "StoreRedux/Slice/SuscritorSlice";
import { Form } from "react-bootstrap";
import { setToastes } from "StoreRedux/Slice/ToastSlice";
import { GetMetodo } from "utils/CarritoLocalStorang";
import { GetValores } from "utils/CarritoLocalStorang";
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag";
import { useEffect, useRef, useState } from "react";
import { Obtenerlinkimagen } from "utils/Querypanel";
import { PagoRapido } from "utils/Querycomnet";
import SweetAlert from "react-bootstrap-sweetalert";
import { registraPagos } from "utils/pagos/Queripagos";
import { clienteInfo } from "utils/DatosUsuarioLocalStorag";
import { cambiarMetodo } from "utils/pagos/Queripagos";
import { OCRApi } from "utils/Querycomnet";
import { Emailcontec } from "utils/Emails/index";
import { logWithCallback } from "utilsstile.js/style";
import { vigilarPagoCompra } from "utils/metaPixel";

// Pixeles: al subir el comprobante, se vigila si la compra queda pagada mientras el cliente sigue en la pagina
// (el OCR puede aprobarla al instante, o un admin al rato). Solo del propio cliente con permiso de cookies.
const vigilarCompraDelComprobante = (compra) => {
    try {
        let info = compra && compra.info_concierto
        if (typeof info === "string") info = JSON.parse(info)
        const item = Array.isArray(info) ? info[0] || {} : {}
        vigilarPagoCompra({
            idCompra: compra && compra.id,
            cedula: compra && compra.cedula,
            total: compra && compra.total_pago,
            evento: { codigoEvento: (compra && compra.codigoEvento) || item.CODIGEVENTO || item.codigoEvento || "", nombreConcierto: item.nombreConcierto || (compra && compra.nombreConcierto) || "" },
            inmediato: true,
        })
    } catch (_e) { /* el pixel nunca frena el pago */ }
}
// OCR habilitado para validar comprobantes previo al registro de pago.
const OCR_HABILITADO = true;
const ModalConfima = (prop) => {
    const { pararcontador } = prop
    let usedispatch = useDispatch()
    const [estado, setEstado] = useState(false)
    const [alert, setAlert] = useState(null)
    const [spiner, setspiner] = useState("")
    const [comproba, setcomprobante] = useState({
        numeroTransaccion: "",
        link_comprobante: "",
        banco: ""
    })
    const [usarNumeroManualAdmin, setUsarNumeroManualAdmin] = useState(true)
    const submitLockRef = useRef(false)
    let modal = useSelector((state) => state.SuscritorSlice.modal)
    let intervalo = useSelector((state) => state.SuscritorSlice.intervalo)
    function iniciarEnvio() {
        if (submitLockRef.current) return false
        submitLockRef.current = true
        setEstado(true)
        return true
    }
    function finalizarEnvio() {
        submitLockRef.current = false
        setEstado(false)
    }
    function cerrar() {
        usedispatch(setModal({ nombre: '', estado: '' }))
        !clienteInfo() ? usedispatch(setToastes({
            show: true,
            message: "Tienes un tiempo límite para reportar el pago, puedes hacerlo desde la opción tickets",
            color: 'bg-primary',
            estado: "Recuerda "
        })) : ""
    }
    function confirmarefectivo() {
        if ($("#valor").val() == "") {
            usedispatch(setToastes({ show: true, message: 'Ingrese monto', color: 'bg-danger', estado: 'Datos vacios' }))

            return
        }
        let datos = {
            "id": clienteInfo() ? modal.estado.id : modal.estado.id,
            "forma_pago": "Efectivo",
            "numeroTransaccion": "",
            "link_comprobante": "",
            "total_pago": $("#valor").val()
        }
        cambiarMetodo(datos).then(ouput => {
            usedispatch(setToastes({ show: true, message: 'Reporte pagado ', color: 'bg-success', estado: 'Se guardo el numero de control' }))

        }).catch(err => {
            $.alert("hubo un error")
        })
        //  usedispatch(setModal({ nombre: '', estado: '' }))
        //  pararcontador()
    }

    function onChange(e) {
        // let img = new Image()

        //if(e.files.size)
        let tamaño = parseInt(e.files[0].size / 1024);
        if (tamaño < 1024 || tamaño == 1024) {
            setcomprobante({
                ...comproba,
                link_comprobante: e.files
            })

        }
        else {
            $("#comprobante").val(null);
            $.alert("Pasate el peso maximo")
            return
        }
    }
    function onhandelChange(e) {
        if (e.name == "comprobante") {
            setcomprobante({
                ...comproba,
                link_comprobante: e.value
            })
        } else {
            setcomprobante({
                ...comproba,
                [e.name]: e.value
            })
        }
    }
    async function onSubmit(e) {
        e.preventDefault();
        if (submitLockRef.current) {
            return
        }
        const esUsuarioNormal = clienteInfo() == null
        const esAdmin = !esUsuarioNormal
        const requiereNumeroManual = esUsuarioNormal
            ? !OCR_HABILITADO
            : (usarNumeroManualAdmin || !OCR_HABILITADO)

        if (comproba.banco == "") {
            usedispatch(setToastes({ show: true, message: 'complete toda la información', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        if (requiereNumeroManual && comproba.numeroTransaccion == "") {
            usedispatch(setToastes({ show: true, message: 'Ingrese el número de comprobante', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        if (requiereNumeroManual && isNaN(String(comproba.numeroTransaccion).trim())) {
            usedispatch(setToastes({ show: true, message: 'solo debe Ingresar Números en el comprobante ', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        if (comproba.link_comprobante[0] == undefined) {
            usedispatch(setToastes({ show: true, message: 'Adjunte una imagen del Comprobante', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        else if ([comproba.banco].some(e => e)) {
            try {
                if (!iniciarEnvio()) {
                    return
                }
                const link = await Obtenerlinkimagen(comproba.link_comprobante[0])
                if (link == null) {
                    usedispatch(
                        setToastes({
                            show: true,
                            message: 'La imagen no se pudo leer Comuníquese con un accesor al número  +593980009000',
                            color: 'bg-warning',
                            estado: 'Hubo un error'
                        }))
                    finalizarEnvio()
                    return;
                }
                setTimeout(async function () {
                    if (OCR_HABILITADO) {
                        OCRApi({
                            "cedulaBeneficiario": "0923980742",
                            "url": link,
                            "cedula": clienteInfo() ? modal.estado.cedula : getDatosUsuariosLocalStorag().id,
                            "valor_pagar": (parseFloat(modal.estado.total_pago)).toFixed(2) 

                        }).then(ocroupt => {
                            const dataOCR = ocroupt?.data || {}
                            const comprobanteDuplicado = Boolean(ocroupt?.duplicado || dataOCR?.duplicado)
                            const comprobante = dataOCR?.numero_documento || String(comproba.numeroTransaccion || "").trim()
                            const montoOCR = Number(dataOCR?.monto)
                            const totalEsperado = Number(parseFloat(modal.estado.total_pago).toFixed(2))
                            const montoCoincide = Number.isFinite(montoOCR) && Math.abs(montoOCR - totalEsperado) <= 0.05
                            const estadoOCR = String(dataOCR?.estado || "").toLowerCase()
                            const nivelSospecha = String(dataOCR?.validacion?.nivel_sospecha || "").toLowerCase()
                            const posibleAdulteracion = Boolean(dataOCR?.validacion?.posible_adulteracion)
                            const tieneNumero = String(comprobante || "").trim().length >= 4

                            // Fuerte: aprobado + sospecha baja + sin adulteracion + monto correcto + numero de comprobante.
                            const esOCRFuerte = Boolean(ocroupt?.success)
                                && estadoOCR === "aprobado"
                                && nivelSospecha === "bajo"
                                && !posibleAdulteracion
                                && montoCoincide
                                && tieneNumero

                            // Debil o inconsistente: se registra en Comprobar para revisión manual.
                            const estadoReporte = esOCRFuerte ? "Pagado" : "Comprobar"
                            const reporte = {
                                "id_usuario": clienteInfo() ? modal.estado.id_usuario : getDatosUsuariosLocalStorag().id,
                                "forma_pago": spiner,
                                "banco": comproba.banco,
                                "bancos": comproba.banco,
                                "link_comprobante": link,
                                "id": clienteInfo() ? modal.estado.id : modal.estado.id,
                                "numeroTransaccion": comprobante,
                                "cedula": clienteInfo() != null ? modal.estado.cedula : getDatosUsuariosLocalStorag().cedula,
                                "estado": estadoReporte,
                                "total_pago": modal.estado.total_pago
                            }

                            registraPagos(reporte).then(ouput => {
                                if (ouput.success) {
                                    vigilarCompraDelComprobante(modal.estado)
                                    finalizarEnvio()
                                    usedispatch(setModal({ nombre: '', estado: '' }))
                                    usedispatch(setToastes({
                                        show: true,
                                        message: comprobanteDuplicado
                                            ? 'Comprobante repetido detectado. Se registró para revisión manual (Comprobar).'
                                            : esOCRFuerte
                                            ? 'Comprobante validado exitosamente. Pago aprobado.'
                                            : 'Comprobante registrado en revisión manual. Espere hasta que sea revisado.',
                                        color: 'bg-success',
                                        estado: comprobanteDuplicado
                                            ? 'Comprobante repetido'
                                            : (esOCRFuerte ? 'Pago aprobado' : 'Comprobante en revisión')
                                    }))
                                    usedispatch(setModal({ nombre: '', estado: '' }))
                                    setTimeout(function () {
                                        window.location.reload()
                                    }, 1000)
                                }
                                else {
                                    finalizarEnvio()
                                    usedispatch(setToastes({ show: true, message: ouput.message, color: 'bg-danger', estado: 'Hubo un error' }))
                                }
                            }).catch(erro => {
                                if (!clienteInfo()) {
                                    let texto = "Nuevo registro de pago de " + getDatosUsuariosLocalStorag().cedula;
                                    // Emailcontec({ movil: ["593980441911", "593991916096"], text: texto }).then(sal => {
                                    //     logWithCallback(sal)
                                    // }).catch(err => {
                                    //     logWithCallback(err)

                                    // })
                                }
                                finalizarEnvio()
                                usedispatch(setToastes({ show: true, message: 'Hubo un error', color: 'bg-danger', estado: 'Hubo un error, intente mas tarde' }))
                            })
                        }).catch(salid => {
                            usedispatch(setToastes({ show: true, message: 'Hubo un error', color: 'bg-danger', estado: "Comuníquese con un acceso al número  +593980009000" }))
                            logWithCallback(salid)
                            finalizarEnvio()
                        })
                    } else {
                        // OCR deshabilitado: se registra comprobante manual para validación/ aprobación posterior.
                        const reporte = {
                            "id_usuario": clienteInfo() ? modal.estado.id_usuario : getDatosUsuariosLocalStorag().id,
                            "forma_pago": spiner,
                            "banco": comproba.banco,
                            "bancos": comproba.banco,
                            "link_comprobante": link,
                            "id": clienteInfo() ? modal.estado.id : modal.estado.id,
                            "numeroTransaccion": comproba.numeroTransaccion,
                            "cedula": clienteInfo() != null ? modal.estado.cedula : getDatosUsuariosLocalStorag().cedula,
                            "estado": "Comprobar",
                            "total_pago": modal.estado.total_pago
                        }
                        registraPagos(reporte).then(ouput => {
                            if (ouput.success) {
                                vigilarCompraDelComprobante(modal.estado)
                                finalizarEnvio()
                                usedispatch(setModal({ nombre: '', estado: '' }))
                                usedispatch(setToastes({
                                    show: true,
                                    message: 'Comprobante registrado. Tu pago queda pendiente de validación manual y tus boletos se emitirán cuando sea aprobado.',
                                    color: 'bg-success',
                                    estado: 'Comprobante en revisión'
                                }))
                                usedispatch(setModal({ nombre: '', estado: '' }))
                                setTimeout(function () {
                                    window.location.reload()
                                }, 1000)
                            }
                            else {
                                finalizarEnvio()
                                usedispatch(setToastes({ show: true, message: ouput.message, color: 'bg-danger', estado: 'Hubo un error' }))
                            }
                        }).catch(erro => {
                            finalizarEnvio()
                            usedispatch(setToastes({ show: true, message: 'Hubo un error', color: 'bg-danger', estado: 'Hubo un error, intente mas tarde' }))
                        })
                    }
                }, 4000)

            } catch (error) {
                finalizarEnvio()
                logWithCallback(error)

            }
        }
    }
    async function onSubmitT(e) {
        e.preventDefault();
        if (submitLockRef.current) {
            return
        }
        if (comproba.numeroTransaccion == "") {
            usedispatch(setToastes({ show: true, message: 'completes toda la información', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        if (comproba.banco == "") {
            usedispatch(setToastes({ show: true, message: 'complete toda la información', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        if (comproba.link_comprobante == "") {
            usedispatch(setToastes({ show: true, message: 'Escribe numero de lote', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        if (isNaN(comproba.numeroTransaccion.trim()) && clienteInfo() == null) {
            usedispatch(setToastes({ show: true, message: 'solo debe Ingresar Números en el comprobante ', color: 'bg-danger', estado: 'Datos vacios' }))
            return
        }
        else if ([comproba.banco, comproba.numeroTransaccion].some(e => e)) {
            try {
                if (!iniciarEnvio()) {
                    return
                }
                //  const link = await Obtenerlinkimagen(comproba.link_comprobante[0])
                setTimeout(async function () {
                    const reporte = {
                        "id_usuario": clienteInfo() ? modal.estado.id_usuario : getDatosUsuariosLocalStorag().id,
                        "forma_pago": "Deposito",
                        "banco": comproba.banco,
                        "bancos": comproba.banco,
                        "link_comprobante": comproba.link_comprobante,
                        "id": clienteInfo() ? modal.estado.id : modal.estado.id,
                        "numeroTransaccion": comproba.numeroTransaccion,
                        "cedula": clienteInfo() != null ? modal.estado.cedula : getDatosUsuariosLocalStorag().cedula,
                        "estado": "Comprobar",
                        "total_pago": modal.estado.total_pago
                    }

                    registraPagos(reporte).then(ouput => {
                        if (ouput.success) {
                            vigilarCompraDelComprobante(modal.estado)
                            finalizarEnvio()
                            usedispatch(setModal({ nombre: '', estado: '' }))
                                    usedispatch(setToastes({ show: true, message: 'Comprobante registrado. Tu pago queda pendiente de validación manual y tus boletos se emitirán cuando sea aprobado.', color: 'bg-success', estado: 'Comprobante en revisión' }))
                            usedispatch(setModal({ nombre: '', estado: '' }))
                            setTimeout(function () {
                                if (!clienteInfo()) {
                                    let texto = "Nuevo registro de pago de " + getDatosUsuariosLocalStorag().cedula;
                                    // Emailcontec({ movil: ["593980441911", "593991916096"], text: texto }).then(opu => logWithCallback(opu))
                                }
                                //  window.location.reload()
                            }, 1000)

                        }
                        else {
                            finalizarEnvio()
                            usedispatch(setToastes({ show: true, message: ouput.message, color: 'bg-danger', estado: 'Hubo un error' }))
                        }
                    }).catch(erro => {
                        finalizarEnvio()
                        usedispatch(setToastes({ show: true, message: 'Hubo un error', color: 'bg-danger', estado: 'Hubo un error, intente mas tarde' }))
                    })
                }, 2000)

            } catch (error) {
                finalizarEnvio()

            }
        }
    }

    useEffect(() => {
        const handler = function (e) {
            var n = (e = e || window.event).keyCode || e.which,
                t = -1 != "0123456789".indexOf(String.fromCharCode(n));
            (t = 8 == n || n >= 35 && n <= 40 || 46 == n || t) || (e.returnValue = !1, e.preventDefault && e.preventDefault())
        }
        $(".numero").on("keypress", handler)
        return () => $(".numero").off("keypress", handler)
    }, []);

    useEffect(() => {
        setspiner(modal.estado.forma_pago)
        setUsarNumeroManualAdmin(true)
        /*$(document).ready(function () {
            $(".modal-content").draggable({
                handle: ".modal-header",
                containment: "#root",
                scroll: false,
            })
        })*/
    }, [modal.nombre == "confirmar" ? true : false])
    return (
        <>

            <Modal
                show={modal.nombre == "confirmar" ? true : false}
                fullscreen={'md-down'}
                centered
            >
                <Modal.Header className=" d-flex  rounded-top-4 m-0   bg-dark   justify-content-between align-items-center">
                    <div className="d-flex  container   justify-content-center text-center" >
                        <h3 className=" p-2 ">
                            Confirmación de Pago
                        </h3>
                    </div>
                    <div className=" float-left " style={{ marginTop: '-45px' }}>
                        <button type="button" className="text-light" onClick={cerrar}>
                            X
                        </button>
                    </div>

                </Modal.Header>
                <Modal.Body className="d-flex align-items-center row">
                    <div className="container d-flex flex-column col-12 ">
                        {spiner != "Tarjeta" ?
                            <form onSubmit={(e) => onSubmit(e)} className="  was-validated">
                                <div className=" p-1">
                                    <div className="d-none text-center"
                                    >
                                        <p style={{
                                            fontWeight: "bold"
                                        }}>Tiempo restante <span className=" text-danger"> {intervalo}</span> </p>

                                    </div>
                                    <h5 className=" font-weight-bold text-danger">Forma de Pagos</h5>
                                    {clienteInfo() != null ?
                                        <select className="form-select" value={spiner}
                                            onChange={(g) => setspiner(g.target.value)}
                                        >
                                            <option value={""} disabled required ></option>
                                            <option value={"Tarjeta"}>Tarjeta</option>
                                            <option value={"Deposito"}>Deposito</option>
                                            <option value={"Efectivo"}>Deposito Efectivo facilito</option>
                                            <option value={"Transferencia"}>Transeferencia</option>

                                        </select> : <select className="form-select" required value={spiner}
                                            onChange={(g) => setspiner(g.target.value)}>
                                            <option value={""} disabled></option>
                                            <option value={"Deposito"}>Deposito</option>
                                            <option value={"Transferencia"}>Transeferencia</option>

                                        </select>}
                                    <h5 className="mt-1" style={{ fontSize: "1.0em" }}>
                                        Selecione el banco al que realizó la transferencia
                                    </h5>
                                    {spiner != "Tarjeta" ? <select className="  form-select" required name="banco" value={comproba.banco} onChange={(g) => onhandelChange(g.target)} >
                                        <option value={""} disabled></option>
                                        <option value={"Pichincha"}>Banco Pichincha</option>
                                        <option value={"Guayaquil"}>Banco Guayaquil</option>
                                        {/* <option value={"Produbanco"}>Banco Produbanco</option>
                                        <option value={"Pacifico"}>Banco Pacifico</option> */}
                                    </select> :
                                        <select className="  form-select" name="banco" required value={comproba.banco} onChange={(g) => onhandelChange(g.target)} ><option value={"Visa"}>Visa</option>
                                            <option value={""} disabled></option>
                                            <option value={"Master"}>Mastercar</option>
                                            <option value={"Diners"}>Diners club</option>
                                            <option value={"Discover"}>Discover</option>
                                            <option value={"America"}>America</option>
                                            <option value={"Alia"}>Alia</option>
                                        </select>}
                                </div>
                                {spiner != "Tarjeta" && clienteInfo() != null && OCR_HABILITADO ?
                                    <div className="p-1">
                                        <div className="d-flex align-items-center justify-content-between border rounded p-2">
                                            <div>
                                                <h6 className="m-0" style={{ fontSize: '0.95em' }}>Número manual de comprobante</h6>
                                                <small className="text-muted">
                                                    {usarNumeroManualAdmin
                                                        ? 'Activado: el operador ingresa el número manualmente.'
                                                        : 'Desactivado: el número se extrae automáticamente por OCR.'}
                                                </small>
                                            </div>
                                            <Form.Check
                                                type="switch"
                                                id="admin-switch-numero-comprobante"
                                                checked={usarNumeroManualAdmin}
                                                onChange={() => setUsarNumeroManualAdmin((prev) => !prev)}
                                                label={usarNumeroManualAdmin ? 'Activado' : 'Desactivado'}
                                            />
                                        </div>
                                    </div>
                                    : ""}
                                {spiner != "Tarjeta" && (clienteInfo() == null ? !OCR_HABILITADO : usarNumeroManualAdmin || !OCR_HABILITADO) ? <div className="p-1">
                                    <h5 style={{ fontSize: '1.0em' }}>
                                        Número de comprobante
                                    </h5>
                                    <input className=" form-control numero"
                                        name="numeroTransaccion"
                                        value={comproba.numeroTransaccion}
                                        minLength={4}
                                        required
                                        placeholder="Ingrese número de comprobante"
                                        onChange={(e) => onhandelChange(e.target)}
                                        type={"text"}
                                    />
                                </div> :
                                    ""}
                                {comproba.banco == "Efectivo" || comproba.banco == "transferencia" ? <div className=" p-1">
                                    <h5 style={{ fontSize: '1.0em' }}>
                                        Valor a Cobrar
                                    </h5>
                                    <input className=" form-control numero"
                                        id="valor"
                                        placeholder="Dato por definir"
                                        required
                                        type={"text"}
                                    />
                                </div> : ""}
                                {spiner != "Tarjeta" ? <div className="p-1" >
                                    <h5 style={{ fontSize: '1.0em' }}>
                                        Adjuntar Comprobante ( imagen jpg ó png)
                                    </h5>
                                    <input type="file" accept="image/*" name="comprobante" id="comprobante"
                                        onChange={(e) => onChange(e.target)}
                                        required
                                        className="form-control"
                                    />
                                    <span className=" text-danger">Tamaño Maximo de la imagen un  1MB</span>
                                </div>
                                    : <div className="p-1" >
                                        <h5 style={{ fontSize: '1.0em' }}>
                                            Link de voucher
                                        </h5>
                                        <input type="text" name="comprobante" id="comprobante"
                                            onChange={(e) => onhandelChange(e.target)} required
                                            className="form-control"
                                        />
                                        <span className=" text-danger">Tamaño Maximo de la imagen un  1MB</span>
                                    </div>
                                }
                                <div className=" p-1 ">
                                    {modal.nombre == "confirmar" && !clienteInfo() ? <span>
                                        Una vez confirmado el deposito su ticket sera enviado  {
                                            GetValores() ? "" : GetValores().envio == "correo " ? "al: correo " + getDatosUsuariosLocalStorag().email : "al: Whatsapp " + getDatosUsuariosLocalStorag().whatsapp
                                        }
                                    </span> : ''}

                                </div>
                                <div className="d-flex container justify-content-center  flex-column text-center">
                                    <div>
                                        {comproba.banco != "Efectivo" && comproba.banco != "transferencia" ?

                                            !estado ? <button className=" btn p-2 btn-success">Confirmar Transferencia</button> : <button disabled className=" btn p-2 btn-success">Confirmar Transferencia</button>

                                            :
                                            ""

                                        }
                                        {
                                            comproba.banco == "transferencia" ? <button className=" btn btn-primary" >Reporte en transferencia </button> : ""
                                        }

                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </form> :
                            <form onSubmit={(e) => onSubmitT(e)} className="was-validated">
                                <div className=" p-1">
                                    <div className="d-none text-center"
                                    >
                                        <p style={{
                                            fontWeight: "bold"
                                        }}>Tiempo restante <span className=" text-danger"> {intervalo}</span> </p>

                                    </div>
                                    <h5 className=" font-weight-bold text-danger">Forma de Pago</h5>



                                    {clienteInfo() != null ?
                                        <select className="form-select" value={spiner} required
                                            onChange={(g) => setspiner(g.target.value)}
                                        >
                                            <option value={""} disabled></option>
                                            <option value={"Deposito"}>Deposito</option>
                                            <option value={"Transferencia"}>Transeferencia</option>

                                        </select> : <select className="form-select" value={spiner}
                                            onChange={(g) => setspiner(g.target.value)}>
                                            <option value={""} disabled></option>
                                            <option value={"Deposito"}>Deposito</option>
                                            <option value={"Transferencia"}>Transeferencia</option>

                                        </select>}
                                    <h5 className="mt-1" style={{ fontSize: "1.0em" }}>
                                        Selecione el banco al que realizó la transferencia
                                    </h5>
                                    {spiner != "Tarjeta" ? <select className="  form-select" required name="banco" value={comproba.banco} onChange={(g) => onhandelChange(g.target)} >
                                        <option value={""} disabled></option>
                                        <option value={"Pichincha"}>Banco Pichincha</option>
                                        <option value={"Guayaquil"}>Banco Guayaquil</option>
                                        {/* <option value={"Produbanco"}>Banco Produbanco</option>
                                        <option value={"Pacifico"}>Banco Pacifico</option> */}
                                    </select> :
                                        <select className="  form-select" name="banco" required value={comproba.banco} onChange={(g) => onhandelChange(g.target)} >
                                            <option value={""} disabled></option>
                                            <option value={"Visa"}>Visa</option>

                                            <option value={"Master"}>Mastercar</option>
                                            <option value={"Diners"}>Diners club</option>
                                            <option value={"Discover"}>Discover</option>
                                            <option value={"America"}>America</option>
                                            <option value={"Alia"}>Alia</option>
                                        </select>}
                                </div>
                                {comproba.banco != "Efectivo" && clienteInfo() != null && OCR_HABILITADO ?
                                    <div className="p-1">
                                        <div className="d-flex align-items-center justify-content-between border rounded p-2">
                                            <div>
                                                <h6 className="m-0" style={{ fontSize: '0.95em' }}>Número manual de comprobante</h6>
                                                <small className="text-muted">
                                                    {usarNumeroManualAdmin
                                                        ? 'Activado: el operador ingresa el número manualmente.'
                                                        : 'Desactivado: el número se extrae automáticamente por OCR.'}
                                                </small>
                                            </div>
                                            <Form.Check
                                                type="switch"
                                                id="admin-switch-numero-comprobante-tarjeta"
                                                checked={usarNumeroManualAdmin}
                                                onChange={() => setUsarNumeroManualAdmin((prev) => !prev)}
                                                label={usarNumeroManualAdmin ? 'Activado' : 'Desactivado'}
                                            />
                                        </div>
                                    </div>
                                    : ""}
                                {comproba.banco != "Efectivo" && (clienteInfo() == null ? !OCR_HABILITADO : usarNumeroManualAdmin || !OCR_HABILITADO) ? <div className=" p-1">
                                    <h5 style={{ fontSize: '1.0em' }}>
                                        Ingrese el número de comprobante de la transferencia
                                    </h5>
                                    <input className=" form-control numero"
                                        name="numeroTransaccion"
                                        value={comproba.numeroTransaccion}
                                        minLength={4}
                                        required
                                        onChange={(e) => onhandelChange(e.target)}
                                        type={"text"}
                                    />
                                </div> :
                                    ""}
                                {comproba.banco == "Efectivo" || comproba.banco == "transferencia" ? <div className=" p-1">
                                    <h5 style={{ fontSize: '1.0em' }}>
                                        Valor a Cobrar
                                    </h5>
                                    <input className=" form-control numero"
                                        id="valor"
                                        placeholder="Dato por definir"
                                        required
                                        type={"text"}
                                    />
                                </div> : ""}
                                {spiner != "Tarjeta" ? <div className="p-1" >
                                    <h5 style={{ fontSize: '1.0em' }}>
                                        Adjuntar Comprobante ( imagen jpg ó png)
                                    </h5>
                                    <input type="file" accept="image/*" name="comprobante" id="comprobante"
                                        required
                                        onChange={(e) => onChange(e.target)}
                                        className="form-control"
                                    />
                                    <span className=" text-danger">Tamaño Maximo de la imagen un  1MB</span>
                                </div>
                                    : <div className="p-1" >
                                        <h5 style={{ fontSize: '1.0em' }}>
                                            numero de lote
                                        </h5>
                                        <input type="text" name="comprobante" id="comprobante"
                                            required
                                            onChange={(e) => onhandelChange(e.target)}
                                            className="form-control"
                                        />
                                        <span className=" text-danger">Tamaño Maximo de la imagen un  1MB</span>
                                    </div>
                                }
                                <div className=" p-1 ">
                                    {modal.nombre == "confirmar" && !clienteInfo() ? <span>
                                        Una vez confirmado el deposito su ticket sera enviado  {
                                            GetValores() ? "" : GetValores().envio == "correo " ? "al: correo " + getDatosUsuariosLocalStorag().email : "al: Whatsapp " + getDatosUsuariosLocalStorag().whatsapp
                                        }
                                    </span> : ''}

                                </div>
                                <div className="d-flex container justify-content-center  flex-column text-center">
                                    <div>
                                        {comproba.banco != "Efectivo" && comproba.banco != "transferencia" ?

                                            !estado ? <button className=" btn p-2 btn-success">Confirmar Transferencia</button> : <button disabled className=" btn p-2 btn-success">Confirmar Transferencia</button>

                                            :
                                            ""

                                        }
                                        {
                                            comproba.banco == "transferencia" ? <button className=" btn btn-primary" >Reporte en transferencia </button> : ""
                                        }

                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                    <div className="col-12 text-center">
                        {clienteInfo() == null ? "" :
                            comproba.banco == "Efectivo" ? <button className=" btn btn-primary" onClick={confirmarefectivo}>Reporte en Efectivo </button> : ""
                        }
                    </div>
                    <div className="col-12 text-center">

                    </div>

                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalConfima;